import React from "react";
import { Back, PageHeader, Title } from "./assets/style";
import { Image } from "@nykaa/payment-ui/src/Image";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { useTheme } from "emotion-theming";
import sanitizeHTML from "helpers/utils/sanitizeHtml";

const MobHeader = (MobHeaderProps: any) => {
    const theme = useTheme();
    /**
     * showIcon by default is true
     */
    const { title, onIconClick, children, fixAtTop = false, icon, color, extraClass, onClick, showIcon = true, dataTestId } = MobHeaderProps;
    const titleHtmlObj = { __html: sanitizeHTML(title) }
    return (
      <PageHeader className={`layout horizontal center ${fixAtTop ? " fixed" : ""} ${extraClass ? extraClass : ""}`} zIndex={2} onClick={onClick} data-testid={dataTestId}>
        {showIcon &&
        <Back type="button" onClick={(e) => { e.preventDefault(); onIconClick(); }} color={color}>
          {icon ?
            icon :
            <Image url={getIcons("", ICONS_NAMES.BACK_ICON)} alt={"arrow"} theme={theme} />
           }
        </Back>}
        <Title className="layout horizontal flex-1 title" color={color}>
          {
              title ? (

                <span dangerouslySetInnerHTML={titleHtmlObj}>
                </span>
              ) : (
                <React.Fragment>
                  {children}
                </React.Fragment>
                  )
          }
        </Title>
      </PageHeader>
    );
};

export default MobHeader;
